import React from 'react';
import classnames from 'classnames';
import { Pinterest, Image, Button, FontIcon, RelatedArticles, SidebarSection } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';
import { RelationFilter } from '@gik/blog/api/wp/PostsUrlBuilder';

export interface IProductSidebarProps extends React.HTMLAttributes<HTMLDivElement> {
  inkindRouteId?: string;
}

export default function ProductSidebar({ inkindRouteId, className }: IProductSidebarProps): JSX.Element {
  const pinterestUrl = 'https://www.pinterest.com/giveinkind/';
  // TODO: use real filters
  const relationFilters: RelationFilter<string[]>[] = [
    {
      taxonomy: 'situation',
      terms: ['new-baby', 'military-support'],
    },
  ];

  const bem = bemBlock('product-sidebar');
  const blockClasses = classnames(bem(), className || '');
  return (
    <div className={blockClasses}>
      <br className="sm" />
      <Image fullWidth src="/img/create-banner.jpg" />
      <SidebarSection title="RELATED ARTICLES">
        <RelatedArticles inkindRouteId={inkindRouteId} relationFilters={relationFilters} />
        <Button block prepend={<FontIcon size="lg" name="article" />} className={bem('button')}>
          See all articles
        </Button>
      </SidebarSection>
      <br />
      <Pinterest
        className="gik-hidden-md-down"
        type="embedUser"
        href={pinterestUrl}
        boardWidth={'460'}
        scaleHeight={'400'}
        scaleWidth={'300'}
      />
    </div>
  );
}
